// extracted by mini-css-extract-plugin
module.exports = {"element":"Heading1_element___SY_R"};